import { FeatureFlagName } from 'shared/clients/client-spa-ConfigurationGroup';
import { useMessages } from 'shared/src/composables/messages/useMessages.composable';
import { DESTINATION_APP_TYPE, MESSAGE_TYPE } from 'shared/src/composables/messages/messages.model';
import { LogoutType } from 'shared/clients/client-spa-AccountGroup';

import AuthorizationService from './authorization/standardAuthorization';
import featureFlagService from './featureFlag';
import { showDevToolsWarning } from './utils/devToolsWarning';

import { MobileAuthorizationStrategy, StandardAuthorizationStrategy } from './authorization/authorizationStrategy';

const { searchParams } = new URL(window.location.href);

const authService = new AuthorizationService();

const { addOnMessageActionAlt, startMessageListener } = useMessages();

addOnMessageActionAlt(
  DESTINATION_APP_TYPE.HOST,
  MESSAGE_TYPE.LOGOUT,
  async (logoutType: LogoutType) => authService.logout(logoutType)
);
startMessageListener();

const main = async () => {
  await featureFlagService.fetchFeatureFlags();

  const mobileLogin = searchParams.get('mobileLogin');
  const mobileAuthFeatureFlag = featureFlagService.getFeatureFlagValue(FeatureFlagName.MobileApp);

  if (mobileLogin && mobileAuthFeatureFlag) {
    await new MobileAuthorizationStrategy().authorize();
    window.history.pushState({}, document.title, window.location.pathname);
  } else {
    const authCode = searchParams.get('code');
    await new StandardAuthorizationStrategy(authCode).authorize();
    if (process.env.NODE_ENV === 'production') {
      showDevToolsWarning();
    }
  }
};

main();
